import { onPath } from '../utils/path';
import { selectMany, getWindow } from '../utils/dom-utils';
import getParameterByName from '../utils/url';

onPath('/partner_thanks', () => {
  const win = getWindow();

  win.addEventListener('load', () => {
    let url = getParameterByName('mbsy_memorable_url');

    if (url) {

      // consider this hack for SEO
      url = url.replace('://mbsy.co', '://www.olark.com');
      selectMany('.referral-link').forEach(elem => {
        elem.innerHTML = url;
      });
    
    } else {
      // There was some sort of validation error, best bet is to redirect back to the previous page,
      // and show some sort of error. (what an annoying API)
      win.document.location.pathname = '/partners.html?error=invalid+email+address';
    }
  });
});